import { encodeBase64 } from './base64'
import { logout } from './auth'

let baseUrl = "https://api.pedidos.vps-kinghost.net/";

class Api {

    static getCep(cep) {
        return Api.get('cep/' + cep);
    }

    static getAllStates() {
        return Api.get('estados');
    }

    static getCitiesByState(idState) {
        return Api.get('cidades/' + idState);
    }

    static getCitiesByName(name) {
        return Api.get('cidade?nome' + name);
    }

    static getGraficoMaiorSaida(dataInicial = null, dataFinal = null, idComprador = null, idEstado = null, quantidadeItens = 5) {
  
        let endpoint = 'grafico/itens-com-maior-saida';
        endpoint = dataInicial ? `${endpoint}?data_inicial=${dataInicial}` : endpoint;

        endpoint += endpoint.includes('?') && quantidadeItens ? '&' : '?';
        endpoint = dataFinal ? `${endpoint}data_final=${dataFinal}` : endpoint;

        endpoint += endpoint.includes('?') && quantidadeItens ? '&' : '?';
        endpoint = idComprador ? `${endpoint}id_comprador=${idComprador}` : endpoint;

        endpoint += endpoint.includes('?') && quantidadeItens ? '&' : '?';
        endpoint = idEstado ? `${endpoint}id_estado=${idEstado}` : endpoint;

        endpoint += endpoint.includes('?') && (dataFinal || dataInicial) ? '&' : '?';
        endpoint = quantidadeItens ? `${endpoint}quantidade_itens=${quantidadeItens}` : endpoint;

        return Api.get(endpoint)
    }

    static getRelatorio(dataInicial = null, dataFinal = null, idComprador = null) {
        let endpoint = 'relatorio/pedidos';
        endpoint = dataInicial ? `${endpoint}?data_inicial=${dataInicial}` : endpoint;
        endpoint += endpoint.includes('?') && dataFinal ? '&' : '?';
        endpoint = dataFinal ? `${endpoint}data_final=${dataFinal}` : endpoint;
        endpoint += endpoint.includes('?') && (dataFinal || dataInicial) ? '&' : '?';
        endpoint = idComprador ? `${endpoint}id_comprador=${idComprador}` : endpoint;

        return Api.get(endpoint)
    }

    static searchItens(nome, idComprador) {
        return Api.get(`itens?filtro=${nome}&id_comprador=${idComprador}`)
    }

    static deletePedido(data) {
        return Api.delete('pedido/' + data.id, data)
    }

    static getPedido(data) {
        return Api.get('pedido/' + data.id, data)
    }

    static savePagamento(data) {
        let promisse;
        data.id ? promisse = Api.put('pagamento/' + data.id, data): promisse = Api.post('pagamento', data);
        return promisse;
    }

    static saveItem(data) {
        let promisse;
        data.id ? promisse = Api.put('item/' + data.id, data): promisse = Api.post('item', data);
        return promisse;
    }

    static saveUsuario(data) {
        let promisse;
        data.id ? promisse = Api.put('usuario/' + data.id, data): promisse = Api.post('usuario', data);
        return promisse;
    }

    static savePedido(data) {
        let promisse;
        data.id ? promisse = Api.put('pedido/' + data.id, data): promisse = Api.post('pedido', data);
        return promisse;
    }

    static deleteItem(data) {
        return Api.delete('item/' + data.id, data)
    }

    static deleteUsuario(data) {
        return Api.delete('usuario/' + data.id, data)
    }

    static getComprador(idComprador) {
        return Api.get('comprador/' + idComprador);
    }

    static getAllUsuarios(filtro = null) {
        return filtro ? Api.get('usuarios?filtro=' + filtro) : Api.get('usuarios');
    }

    static getAllItens(filtro = null) {
        return filtro ? Api.get('itens?filtro=' + filtro) : Api.get('itens');
    }

    static getTodosItens(filtro = null) {
        return filtro ? Api.get('itens/all?filtro=' + filtro) : Api.get('itens/all');
    }

    static getAllPagamentoByComprador(idComprador) {
        return Api.get('pagamentos/comprador/' + idComprador);
    }

    static getAllPedidos(filtro = null, dataInicial = null, dataFinal = null) {

        let endpoint = 'pedidos';
        endpoint = dataInicial ? `${endpoint}?data_inicial=${dataInicial}` : endpoint;

        endpoint += endpoint.includes('?') ? '&' : '?';
        endpoint = dataFinal ? `${endpoint}data_final=${dataFinal}` : endpoint;

        endpoint += endpoint.includes('?') ? '&' : '?';
        endpoint = filtro ? `${endpoint}filtro=${filtro}` : endpoint;
        
        return Api.get(endpoint); 
    }

    static getPedidosTotal() {
        return Api.get('pedidosTotal');
    }

    static getItensTotal() {
        return Api.get('itensTotal');
    }

    static getItemLastPrice(idComprador, idItem) {
        return Api.get(`item/price?id_comprador=${idComprador}&id_item=${idItem}`);
    }

    static getAllCompradores(filtro = null) {
        return filtro ? Api.get('compradores?filtro=' + filtro) : Api.get('compradores');
    }

    static saveComprador(data) {
        let promisse;
        data.id ? promisse = Api.put('comprador/' + data.id, data): promisse = Api.post('comprador', data);
        return promisse;
    }

    static deletePagamento(data) {
        return Api.delete('pagamento/' + data.id, data)
    }

    static deleteComprador(data) {
        return Api.delete('comprador/' + data.id, data)
    }

    static login(cpf, senha) {
        let basic = 'Basic ' + encodeBase64(cpf + ':' + senha)
        return Api.send('POST', 'entrar', basic)
    }
    
    static get(endpoint) {
        let auth = 'Bearer ' + localStorage.getItem('accessToken')
        return Api.send('GET', endpoint, auth)
    }

    static post(endpoint, data) {
        const auth = 'Bearer ' + localStorage.getItem('accessToken')
        return Api.send('POST', endpoint, auth, data);
    }

    static put(endpoint, data) {
        const auth = 'Bearer ' + localStorage.getItem('accessToken')
        return Api.send('PUT', endpoint, auth, data);
    }

    static delete(endpoint, data) {
        const auth = 'Bearer ' + localStorage.getItem('accessToken')
        return Api.send('DELETE', endpoint, auth, data);
    }

    static print(css, idElement) {
        let printContents;
        printContents = document.getElementById(idElement).innerHTML;
        let printableWindow = window.open('', 'PRINT', 'height=400,width=600');
        printableWindow.document.write(
            `<html>
                <head>
                    <title>Pedido</title>
                </head>
                <style>${css}</style>
                <body>
                    ${printContents}
                </body>
            </html>
        `);
        
        printableWindow.document.close();
        printableWindow.focus();
        printableWindow.print();
        printableWindow.close();
    }

    static send(method, endpoint, authorization = null, data = null) {
        const url = baseUrl + endpoint;
        return fetch(url, {
            body: data !== null ? JSON.stringify(data) : data, // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authorization
            },
            method: method, // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        }).then(response => {
            if (endpoint.includes('entrar')) {
                return new Promise(function(resolve, reject) {
                    resolve(response)
                })
            } else {
                if (response.status === 401) {
                    logout();
                    window.location.href='/login';
                } else {
                    return new Promise(function(resolve, reject) {
                        resolve(response)
                    })
                }
            }
        }).catch(error => {
            return new Promise(function(resolve, reject) {
                reject(error)
            })
        })
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/common/api.js